<template>
    <v-simple-table v-if="tariffs > 0" dense class="totals-table--bordered">
        <thead>
            <tr>
                <th class="totals-th--bordered">
                    <TranslatableStringComponent :tstring="{string: 'tariffRecoverySurcharge'}" />
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="totals-td--bordered">
                    <span>{{ dollars(tariffs) }}</span>
                </td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
import { mapGetters } from 'vuex'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'TariffSection',
    components: {
        TranslatableStringComponent,
    },
    data() {
        return { attrs: null }
    },
    computed: {
        ...mapGetters({
            tariffs: 'cart/fetchCartTariffTotal',
        }),
    },
}
</script>

<style></style>
